import { LinkTo } from '@ember/routing';
import { t } from 'ember-intl';
import Tile from '../tile';
import svgJar from 'ember-svg-jar/helpers/svg-jar';

<template>
  <LinkTo @route="authenticated.planning-for-college.scholarship">
    <Tile @headerText={{t "dashboard_tiles.scholarship_info"}}>
      <:description>
        <span>{{t "dashboard_tiles.helpful_info"}}</span>
      </:description>
      <:image>
        {{svgJar "startup" width="80%" height="100%" role="img" desc=(t "svg.startup")}}
      </:image>
    </Tile>
  </LinkTo>
</template>
